// @flow

import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { localize } from "redux-i18n";
import * as sharedSelectors from "@modules/shared/selectors";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import type { ReferralProcess } from "@modules/service/reducer/referrals/types";
import * as serviceSelectors from "@modules/service/selectors";
import actionCreators from "@modules/service/actionCreator";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "@components";
import { HierarchyScopeForm } from "@modules/service/components/hierarchy-scope";
import type { HierarchyAssignment } from "@modules/service/types";

type PropsFromState = $Exact<{
  current: ?ReferralProcess,
  hierarchy: ?HierarchyTree,
  assignments: Array<HierarchyAssignment>,
  isReferralAssignmentsValid: boolean,
}>;

type PropsFromDispatch = $Exact<{
  setAssignments: typeof actionCreators.SetReferralAssignments,
  updateAssignments: typeof actionCreators.UpdateReferralAssignments,
}>;

type OwnProps = $Exact<{
  clientId: number,
  onClose: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class ReferralEditAssignmentsModal extends Component<Props> {
  handleSubmitReferralDraft = () => {
    if (this.props.current && this.props.current.hierarchyAssignments) {
      this.props.updateAssignments({
        container: this.props.current,
        assignments: this.props.assignments,
      });
    }
    this.props.onClose();
  };

  handleChanges = (data: Array<HierarchyAssignment>) => {
    this.props.setAssignments(data);
  };

  render() {
    return (
      <Modal className="modal-large">
        <ModalHeader className="d-flex justify-content-between" toggle={this.props.onClose}>
          {this.props.t("REFERRAL_EDIT_HIERARCHY_SCOPE_TITLE", {
            ...(this.props.current ? { processId: this.props.current.id } : {}),
          })}
        </ModalHeader>
        <ModalBody className="d-flex flex-column align-content-center">
          <div className="w-100 d-flex justify-content-center">
            <div className="col-sm-12">
              {this.props.hierarchy && this.props.assignments ? (
                <HierarchyScopeForm
                  hierarchy={this.props.hierarchy}
                  assignments={this.props.assignments}
                  onChange={this.handleChanges}
                />
              ) : null}
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onClose}>
            {this.props.t("CANCEL")}
          </Button>
          <Button
            materialIcon="save"
            onClick={this.handleSubmitReferralDraft}
            disabled={!this.props.isReferralAssignmentsValid}
          >
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    current: serviceSelectors.getCurrentReferral(state),
    hierarchy: sharedSelectors.getHierarchyTree(state),
    assignments: serviceSelectors.getReferralAssignments(state),
    isReferralAssignmentsValid: serviceSelectors.isReferralAssignmentsValid(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setAssignments: actionCreators.SetReferralAssignments,
  updateAssignments: actionCreators.UpdateReferralAssignments,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(ReferralEditAssignmentsModal);
